import { useCallback, useMemo, useState } from 'react';

export interface CreditSystemState {
  credits: number | null;
  loading: boolean;
  error: string | null;
  isLowOnCredits: boolean;
  isCriticallyLowOnCredits: boolean;
  bypassEnabled: boolean;
}

export interface CreditContextValue extends CreditSystemState {
  fetchCredits: () => Promise<void>;
  deductCredits: (_amount: number) => Promise<boolean>;
  addCredits: (_amount: number) => Promise<boolean>;
  hasEnoughCredits: (_required: number) => boolean;
}

/** B2B: org billing handles credits; single-optimize flow always has enough. */
export function useCreditSystem(): CreditContextValue {
  const [loading] = useState(false);
  const fetchCredits = useCallback(async () => {}, []);
  const deductCredits = useCallback(async () => true, []);
  const addCredits = useCallback(async () => true, []);
  const hasEnoughCredits = useCallback(() => true, []);
  return useMemo(
    () => ({
      credits: 999999,
      loading,
      error: null,
      isLowOnCredits: false,
      isCriticallyLowOnCredits: false,
      bypassEnabled: true,
      fetchCredits,
      deductCredits,
      addCredits,
      hasEnoughCredits,
    }),
    [loading, fetchCredits, deductCredits, addCredits, hasEnoughCredits],
  );
}
